import React from "react";

/**
 * Logo FB Environnement — PNG détouré (fond transparent) du badge officiel.
 */
const LOGO_URL = "/images/logo-fb.png";

export default function Logo({ size = 64, withText = false, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-3 ${className}`}>
      <img
        src={LOGO_URL}
        alt="FB Environnement"
        width={size}
        height={size}
        style={{ width: size, height: size, objectFit: "contain", display: "block" }}
      />
      {withText && (
        <span className="leading-tight">
          <span className="font-heading font-black text-xl tracking-tight block text-[#1F6B2E]">
            FB Environnement
          </span>
          <span className="text-[10px] uppercase tracking-[0.2em] font-bold text-stone-500">
            Centre de recyclage
          </span>
        </span>
      )}
    </span>
  );
}
